import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Jobs from './pages/Jobs';
import JobDetail from './pages/JobDetail';
import PostResume from './pages/PostResume';
import About from './pages/About';
import Contact from './pages/Contact';
import Services from './pages/Services';
import Employers from './pages/Employers';
import IndustrySolutions from './pages/IndustrySolutions';
import EmployerRequirements from './pages/EmployerRequirements';
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminJobs from './pages/admin/AdminJobs';
import AdminCategories from './pages/admin/AdminCategories';
import AdminLocations from './pages/admin/AdminLocations';
import AdminEmployers from './pages/admin/AdminEmployers';
import AdminApplications from './pages/admin/AdminApplications';
import AdminResumes from './pages/admin/AdminResumes';
import AdminRequirements from './pages/admin/AdminRequirements';
import AdminEnquiries from './pages/admin/AdminEnquiries';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" toastOptions={{ duration: 3000 }} />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/jobs/:id" element={<JobDetail />} />
          <Route path="/post-resume" element={<PostResume />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services/:type" element={<Services />} />
          <Route path="/employers" element={<Employers />} />
          <Route path="/industry-solutions" element={<IndustrySolutions />} />
          <Route path="/employer-requirements" element={<EmployerRequirements />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="jobs" element={<AdminJobs />} />
            <Route path="categories" element={<AdminCategories />} />
            <Route path="locations" element={<AdminLocations />} />
            <Route path="employers" element={<AdminEmployers />} />
            <Route path="applications" element={<AdminApplications />} />
            <Route path="resumes" element={<AdminResumes />} />
            <Route path="requirements" element={<AdminRequirements />} />
            <Route path="enquiries" element={<AdminEnquiries />} />
          </Route>
        </Routes>
        <Footer />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
